export default __webpack_public_path__ + "static/media/AlarmDateRange.43ba540e.png";